import Header from "./header";
import { Outlet } from "react-router-dom";
import useGetSidebarItems from "../hooks/use-get-sidebar-routes";
import Spinner from "../components/common/Spinner";
import { queryClient } from "../App";
import { ApiResponse, IStaffAuthTokenRequest } from "../utils/types";

const Layout = () => {
  const { data, isLoading, isError } = useGetSidebarItems();

  const staffAuthData: ApiResponse<IStaffAuthTokenRequest> | undefined =
    queryClient.getQueryData(["auth-user"]);

  if (isLoading) {
    return <Spinner fullScreenOverlay className="z-[100]" />;
  }

  if (isError || !data || !staffAuthData) {
    return <div>Something went wrong</div>;
  }

  return (
    <div className="flex flex-col min-h-screen">
      <div
        id="body-wrapper"
        className="min-h-screen w-full bg-background transition-all"
      >
        <Header
          routes={data}
          accesspages={staffAuthData?.result.data.department.accessPages}
        />
        <div className="">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default Layout;
